import { ImageComponent } from 'BreetComponents';
import type { JSX } from 'react';

export const DefaultInputValue = ({
	icon,
	iconAs,
	value,
}: {
	icon: JSX.Element | string | undefined;
	iconAs: 'text' | 'image' | 'element';
	value?: string | undefined;
}) => {
	const iconValue = icon ?? '';
	const isImage = iconAs === 'image';
	const valueItem = value ?? '';

	if (!isImage && typeof iconValue === 'string') return <>{iconValue + valueItem}</>;

	if (isImage && typeof iconValue === 'string' && iconValue)
		return (
			<>
				<ImageComponent
					src={iconValue}
					alt='drop down'
				/>
				{valueItem}
			</>
		);

	return (
		<>
			{iconValue}
			{valueItem}
		</>
	);
};
